import admin from './admin';
import contentApi from './content-api';

export default {
  admin,
  'content-api': contentApi,
};
